import client from "./client";
import { cachedTaskLookups, cachedJobLookups } from "../store/store";
import { extractErrorMessage } from "../utils/misc";
// fetch and cache /v1/Tasks/lookups
export async function fetchTaskLookups() {
    // if (get(cachedTaskLookups)) {
    // 	// if cached task lookups already exists, use it
    // 	const taskLookups = get(cachedTaskLookups);
    // 	return taskLookups;
    // }
    try {
        // else, fetch task lookups from API and store in cache
        const res = await client("/v1/Tasks/lookups", {
            method: "GET",
            version: "Tasking",
        });
        cachedTaskLookups.set(res.data);
        return;
    }
    catch (error) {
        console.log(error);
        extractErrorMessage(error);
        throw error;
    }
}
// fetch and cache /v1/Jobs/lookups
export async function fetchJobLookups() {
    // if (get(cachedJobLookups)) {
    // 	// if cached job lookups already exists, use it
    // 	const jobLookups = get(cachedJobLookups);
    // 	return jobLookups;
    // }
    try {
        // else, fetch job lookups from API and store in cache
        const res = await client("/v1/Jobs/lookups", {
            method: "GET",
            version: "Tasking",
        });
        cachedJobLookups.set(res.data);
        return;
    }
    catch (error) {
        console.log(error);
        extractErrorMessage(error);
        throw error;
    }
}
